import { useOrganizationList } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router';

export const RequireMerchantLayout = () => {
  const { isLoaded, setActive, userMemberships } = useOrganizationList({
    userMemberships: {
      infinite: true,
      pageSize: 100
    }
  });
  const { slug } = useParams<{ slug: string }>();

  const found = userMemberships.data?.find((org) => org.organization.slug === slug);
  const isFetching = userMemberships.isFetching;

  useEffect(() => {
    if (isLoaded && found && !isFetching) {
      setActive({ organization: found.organization.id }).catch((e: unknown) => {
        console.error('cannot set active org', e);
      });
    }
  }, [found, setActive, isLoaded, isFetching]);

  if (isFetching) {
    return null;
  }

  // If we've loaded all memberships and can't find this organization in the list,
  // it either doesn't exist or the user doesn't have access
  if (isLoaded && !found) {
    return <Navigate to={`/merchants/${slug!}/request-access?error=organization_not_found`} />;
  }

  return <Outlet />;
};
